module.exports = __webpack_public_path__ + "logo_57-d5860cf28d288fb8f6d3cab5fdb18d35.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_57.png
// module id = 1143
// module chunks = 0 1